import styled from "styled-components";
import Edit_Product from "components/widgets/forms/setup/Edit_Product";

// Styled Components
const Container = styled.div`
  padding: 24px;
  max-width: 100%;
  margin: 0 auto;
`;

const DetailsSection = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  flex-wrap: wrap;
`;

const DetailsCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  min-width: 300px;
`;


function NewProduct(props) {
  return (
    <Container>
      <DetailsSection>
        <DetailsCard>
          <Edit_Product />
        </DetailsCard>
      </DetailsSection>
    </Container>
  );
}

export default NewProduct;